import { CalendarPlus2, Users } from "lucide-react";

// Mobile-first landing for the concierge desk — two big choices, thumb-friendly
export const OwnerHub = ({ onClients, onNew }) => (
  <div data-testid="owner-hub" className="flex min-h-[72vh] flex-col items-center justify-center px-6">
    <img src="/assets/logo.png" alt="" className="h-16 w-auto mix-blend-screen" />
    <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.3em] text-amber-300/80">Concierge Desk</p>
    <h1 className="mt-2 text-center font-serif text-3xl font-light text-neutral-50">Where to, boss?</h1>
    <div className="mt-10 grid w-full max-w-sm gap-4">
      <button
        data-testid="hub-current-clients"
        onClick={onClients}
        className="flex items-center gap-4 border border-amber-500/40 bg-amber-500/[0.06] px-6 py-6 text-left transition-colors active:bg-amber-500/20"
      >
        <Users className="h-9 w-9 shrink-0 text-amber-300" />
        <span>
          <span className="block font-serif text-xl text-neutral-50">Current clients</span>
          <span className="mt-1 block text-xs leading-relaxed text-neutral-500">
            Open any itinerary — add prices, tick things booked, or drop in something new
          </span>
        </span>
      </button>
      <button
        data-testid="hub-new-booking"
        onClick={onNew}
        className="flex items-center gap-4 border border-amber-400 bg-amber-500 px-6 py-6 text-left transition-colors active:bg-amber-400"
      >
        <CalendarPlus2 className="h-9 w-9 shrink-0 text-black" />
        <span>
          <span className="block font-serif text-xl text-black">New booking</span>
          <span className="mt-1 block text-xs leading-relaxed text-black/60">
            A fresh itinerary — rough notes in, schedule out, save it in the system
          </span>
        </span>
      </button>
    </div>
  </div>
);
